import {
  SET_RENDERING_UPDATE_RECORD_LIST,
  SET_RENDERING_UPDATE_RECORD_LIST_PAGE,
  SET_RENDERING_UPDATE_RECORD_LIST_PAGE_SIZE,
  SET_RENDERING_UPDATE_RECORD_LIST_PAGE_TOTAL,
  SET_RENDERING_UPDATE_RECORD_LIST_QUERY,
  SET_RENDERING_UPDATE_RECORD_LIST_SEARCHING,
  SET_RENDERING_UPDATE_RECORD_LIST_EXPORTINGRECORD,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'
import files from 'file-saver'
import {getHeaderName, objectTrim} from '@/utils'
import { checkUserName } from '@/views/User/utils'

const initQuery = () => {
  return {
    pageNum: 1,
    pageSize: 50,
    userName: '',  // 用户名
    userId: '',    // 用户id
    startDate: '', // 开始时间
    endDate: '',   // 结束时间
  }
}

const state = {
  searching: false,
  initQuery: initQuery(),
  exportingRecord: false,
  renderingUpdateRecord: {
    list: [],
    // listCurrentPage: 1,
    listPageTotal: 0,
    // listPageSize: 50,
    query: initQuery(),
  },
}

const mutations = {
  [SET_RENDERING_UPDATE_RECORD_LIST] (state, payload) {
    state.renderingUpdateRecord.list = payload
  },
  [SET_RENDERING_UPDATE_RECORD_LIST_PAGE] (state, payload) {
    state.renderingUpdateRecord.query.pageNum = payload
  },
  [SET_RENDERING_UPDATE_RECORD_LIST_PAGE_SIZE] (state, payload) {
    state.renderingUpdateRecord.query.pageSize = payload
  },
  [SET_RENDERING_UPDATE_RECORD_LIST_PAGE_TOTAL] (state, payload) {
    state.renderingUpdateRecord.listPageTotal = payload
  },
  [SET_RENDERING_UPDATE_RECORD_LIST_QUERY] (state, payload) {
    state.renderingUpdateRecord.query = {
      ...state.renderingUpdateRecord.query,
      ...payload,
    }
  },
  [SET_RENDERING_UPDATE_RECORD_LIST_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_RENDERING_UPDATE_RECORD_LIST_EXPORTINGRECORD] (state, payload) {
    state.exportingRecord = payload
  },
}

const actions = {
  // 获取专业版效果图升级记录列表
  async setRenderingUpdateRecordsList ({ commit, state, dispatch }, payload) {
    try {
      let query = {}
      _.forIn(state.renderingUpdateRecord.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        pageNo: state.renderingUpdateRecord.query.pageNum,
        pageSize: state.renderingUpdateRecord.query.pageSize,
        ...payload,
      }
      if (payload && !payload.userName && params.userName) {
        delete params.userName
      }
      const {data, code} = await api.userApi.getPictureProList(params)
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { userName, ...other } = params
          dispatch('setRenderingUpdateRecordsList', {
            ...other,
            userId,
          })
        },
      })
      const {items, total} = data
      commit(SET_RENDERING_UPDATE_RECORD_LIST_SEARCHING, false)
      commit(SET_RENDERING_UPDATE_RECORD_LIST_PAGE_TOTAL, total)
      commit(SET_RENDERING_UPDATE_RECORD_LIST, items)
    } catch (error) {
      commit(SET_RENDERING_UPDATE_RECORD_LIST, [])
      commit(SET_RENDERING_UPDATE_RECORD_LIST_PAGE_TOTAL, 0)
    }
  },
  // 初始化专业版效果图升级记录列表
  async initRenderingUpdateRecordsList ({commit, dispatch}) {
    let query = initQuery()
    commit(SET_RENDERING_UPDATE_RECORD_LIST_QUERY, query)
    dispatch('changeRenderingUpdateRecordsListPage', {currentPage: 1})
  },
  // 专业版效果图升级记录列表改变页码
  async changeRenderingUpdateRecordsListPage ({commit, state, dispatch}, payload) {
    commit(SET_RENDERING_UPDATE_RECORD_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('setRenderingUpdateRecordsList')
  },
  // 专业版效果图升级记录列表改变每页显示的条数
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_RENDERING_UPDATE_RECORD_LIST_SEARCHING, true)
    commit(SET_RENDERING_UPDATE_RECORD_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeRenderingUpdateRecordsListPage', {currentPage: 1})
  },
  changeQuery ({commit}, payload) {
    commit(SET_RENDERING_UPDATE_RECORD_LIST_QUERY, payload)
  },
  async exportRecord ({commit, state, dispatch}, payload) {
    const query = objectTrim({
      ...state.renderingUpdateRecord.query,
      userName: state.renderingUpdateRecord.query.userName,
      userId: state.renderingUpdateRecord.query.userId,
      startDate: state.renderingUpdateRecord.query.startDate,
      pageNo: state.renderingUpdateRecord.query.pageNum,
      pageSize: state.renderingUpdateRecord.query.pageSize,
      ...payload,
    })
    if (payload && !payload.userName && query.userName) {
      delete query.userName
    }
    commit(SET_RENDERING_UPDATE_RECORD_LIST_EXPORTINGRECORD, true)
    const res = await api.userApi.exportPictureProList(query)
    const {headers, data} = res
    try {
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (error) {
      commit(SET_RENDERING_UPDATE_RECORD_LIST_EXPORTINGRECORD, false)
      const reader = new FileReader()
      reader.onload = () => {
        const result = JSON.parse(reader.result)
        const { code, data } = result
        checkUserName({
          code,
          data,
          callback: ({userId}) => {
            const { userName, ...other } = query
            dispatch('exportRecord', {
              ...other,
              userId,
            })
          },
        })
      }
      reader.readAsText(res.data)
    }
    commit(SET_RENDERING_UPDATE_RECORD_LIST_EXPORTINGRECORD, false)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
